<template>
    <div>
        <b-row v-if="tipo == '1'">
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">{{ titulo }}</span>
                    </b-card-header>
                    <b-card-body>
                        <slot name="controles"></slot>
                        <app-tabela
                            idTabela="tbEtapas"
                            :itens="etapas"
                            :campos="campos"
                            :camposFiltro="camposFiltro"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false"
                        >
                            <template slot="botoes">
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="codProjeto" slot-scope="data">
                                <span
                                    >Código:
                                    <strong>{{ data.codProjeto }}</strong></span
                                ><br />
                                <span
                                    >Projeto:
                                    <strong>{{ data.projeto }}</strong></span
                                ><br />
                                <span
                                    >Unidade:
                                    <strong>{{ data.unidade }}</strong></span
                                ><br />
                                <span
                                    >Gestor:
                                    <strong>{{ data.gestor }}</strong></span
                                ><br />
                                <span
                                    >Gerente:
                                    <strong>{{ data.gerente }}</strong></span
                                ><br />
                                <span
                                    >Ficha Técnica:
                                    <strong>{{
                                        data.fichaTecnica
                                    }}</strong></span
                                >
                            </template>
                            <template slot="status" slot-scope="data">
                                <app-status
                                    :status="data.status.toUpperCase()"
                                ></app-status>
                            </template>
                            <template slot="valorHora" slot-scope="data">{{
                                data.valorHora | currency
                            }}</template>
                            <template slot="idMov" slot-scope="data">
                                {{ data.idMov }}
                                <status-id-mov :etapa="data"></status-id-mov>
                                <btn-erro-comprometimento
                                    :etapa="data"
                                    :servicos="servicos"
                                    :permiteAcesso="
                                        permiteAcessoErroComprometimento
                                    "
                                ></btn-erro-comprometimento>
                            </template>
                            <template slot="valorTotal" slot-scope="data">{{
                                data.valorTotal | currency
                            }}</template>
                            <template slot="acoes" slot-scope="data">
                                <slot name="etapaAcoes" v-bind="data"></slot>
                            </template>
                            <template
                                slot="etapaSelecao"
                                slot-scope="data"
                                v-if="incluirSelecao"
                            >
                                <slot name="etapaSelecao" v-bind="data"></slot>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="tipo == '2'">
            <b-col sm="12">
                <h5 class="heading-1 mb-4 text-primary">
                    <span>{{ titulo }}</span>
                </h5>
                <app-tabela
                    idTabela="tbEtapas"
                    :itens="etapas"
                    :campos="campos"
                    :camposFiltro="camposFiltro"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="codProjeto" slot-scope="data">
                        <span
                            >Código:
                            <strong>{{ data.codProjeto }}</strong></span
                        ><br />
                        <span
                            >Projeto: <strong>{{ data.projeto }}</strong></span
                        ><br />
                        <span
                            >Unidade: <strong>{{ data.unidade }}</strong></span
                        ><br />
                        <span
                            >Gestor: <strong>{{ data.gestor }}</strong></span
                        ><br />
                        <span
                            >Ficha Técnica:
                            <strong>{{ data.fichaTecnica }}</strong></span
                        >
                    </template>
                    <template slot="status" slot-scope="data">
                        <app-status
                            :status="data.status.toUpperCase()"
                        ></app-status>
                    </template>
                    <template slot="valorHora" slot-scope="data">{{
                        data.valorHora | currency
                    }}</template>
                    <template slot="idMov" slot-scope="data">
                        {{ data.idMov }}
                        <status-id-mov :etapa="data"></status-id-mov>
                        <btn-erro-comprometimento
                            :etapa="data"
                            :servicos="servicos"
                            :permiteAcesso="permiteAcessoErroComprometimento"
                        ></btn-erro-comprometimento>
                    </template>
                    <template slot="valorTotal" slot-scope="data">{{
                        data.valorTotal | currency
                    }}</template>
                    <template slot="acoes" slot-scope="data">
                        <slot name="etapaAcoes" v-bind="data"></slot>
                    </template>
                    <template
                        slot="etapaSelecao"
                        slot-scope="data"
                        v-if="incluirSelecao"
                    >
                        <slot name="etapaSelecao" v-bind="data"></slot>
                    </template>
                </app-tabela>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import StatusIdMov from './StatusIdMov'
import BtnErroComprometimento from './BtnErroComprometimento'

export default {
    props: {
        etapas: {
            type: Array,
            default: () => []
        },

        incluirSelecao: {
            type: Boolean,
            default: false
        },

        titulo: {
            type: String,
            default: 'Etapas'
        },

        servicos: {
            type: Object,
            default: () => ({})
        },

        permiteAcessoErroComprometimento: {
            type: Boolean,
            default: () => false
        },

        tipo: {
            type: String,
            default: () => '1'
        }
    },

    data() {
        return {
            camposFiltro: ['projeto', 'unidade', 'gestor', 'fichaTecnica'],

            campos: [
                {
                    key: 'codProjeto',
                    label: 'Projeto',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'idEtapa',
                    label: 'Parcela',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'idEtapaCliente',
                    label: 'Etapa',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'cliente',
                    label: 'Cliente',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'servico',
                    label: 'Serviço',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'inicioEtapa',
                    label: 'Início',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'terminoEtapa',
                    label: 'Término',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'horasEtapa',
                    label: 'Qtd Horas',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'valorHora',
                    label: 'Valor Hora',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'status',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'idMov',
                    label: 'Comprometimento',
                    filterable: true
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {},

    computed: {},

    created() {
        if (this.incluirSelecao) {
            this.campos.pop()
            this.campos.unshift({
                key: 'etapaSelecao',
                label: ''
            })
        }
    },

    components: {
        StatusIdMov,
        BtnErroComprometimento
    }
}
</script>
